import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import Filter from './Filter';
import TableC from '../../basicElement/TableC';
import SideNav from '../SumEffSider';
import moment from 'moment';

const monthFormat = "YYYY-MM";

class MonthlySummary extends Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        const searchParams = {
            settlementType,
            begin: sessionStorage.curRole === 'CRC' ? moment().subtract(3, 'months').format(monthFormat) : moment().subtract(11, 'M').format(monthFormat),
            end: moment().format(monthFormat),
        };
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams,
            curParams: { ...searchParams },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            currentDate: '',
        }
    }

    componentDidMount() {
        this.loadData();
        this.getDate();
    }

    componentDidUpdate(prevProps) {
        const { settlementType } = this.props
        if (settlementType !== prevProps.settlementType) {
            const { curParams, searchParams } = this.state;
            curParams.settlementType = settlementType;
            searchParams.settlementType = settlementType;
            this.setState({ curParams, searchParams }, () => {
                this.loadData();
            });
        }
    }

    // 获取系统时间
    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({ currentDate: date });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.queryMonthSummary,
            data: {
                offset: current,
                limit: pageSize - 1,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { total, dataList: { datas, totalCount } } = res.data;
                const ct = Number((totalCount / (pageSize - 1)).toFixed(0)) + (totalCount % (pageSize - 1) > 0 ? 1 : 0);
                pagination.total = totalCount + ct;

                const data = datas || [];
                if (data.length) {
                    data.push({
                        ...total,
                        showDate: '汇总',
                    });
                }

                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.summary.exportMonthSummary;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const columns = [{
            title: '时间',
            dataIndex: 'showDate',
            key: 'showDate',
            sorter: true,
            width: 100,
            fixed: 'left',
        }, {
            title: '本月工时数',
            dataIndex: 'manHourShow',
            key: 'manHourShow',
            sorter: true,
            width: 120,
            render: text => text ? `${text}h` : '0h',
        }, {
            title: '本月FTE数',
            dataIndex: 'fteString',
            key: 'fteString',
            sorter: true,
            width: 120,
        }];
        if (!isUnBlind) {
            columns.push({
                title: '本月知情数',
                dataIndex: 'amountInformed',
                key: 'amountInformed',
                sorter: true,
                width: 120,
            }, {
                title: '本月筛选数',
                dataIndex: 'amountFilter',
                key: 'amountFilter',
                sorter: true,
                width: 120,
            }, {
                title: '本月随机(入组)数',
                dataIndex: 'amountRandom',
                key: 'amountRandom',
                sorter: true,
                width: 130,
            });
        }
        columns.push({
            title: '本月完成访视数',
            dataIndex: 'amountVisit',
            key: 'amountVisit',
            sorter: true,
            width: 130,
        }, {
            title: '本月退出数',
            dataIndex: 'amountDrop',
            key: 'amountDrop',
            sorter: true,
            width: 120,
        }, {
            title: '本月方案违背数',
            dataIndex: 'amountViolation',
            key: 'amountViolation',
            sorter: true,
            width: 130,
        }, {
            title: '本月重大事件数',
            dataIndex: 'majorEventNum',
            key: 'majorEventNum',
            sorter: true,
            width: 130,
        });
        if (!isUnBlind) {
            columns.push({
                title: '本月SAE数',
                dataIndex: 'amountSae',
                key: 'amountSae',
                sorter: true,
                width: 120,
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams, currentDate } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="monthlySummary" />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        currentDate={currentDate}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>
                        ]}
                    />
                    <TableC
                        data={data}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        className="monthlySummary"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(MonthlySummary);


// WEBPACK FOOTER //
// ./src/components/sumTotal/monthlySummary/index.js